module.exports = __webpack_public_path__ + "static/media/target.c0beb4f8.svg";